import { Fieldset } from "./util/Fieldset.js";
import { S } from "./Squaremap.js";

/**
 * Right-hand sidebar (worlds + players). The old "pin" is gone: visibility is
 * controlled solely by the top-right toggle button, and when shown the sidebar
 * stays open (no hover-to-collapse).
 */
class Sidebar {
    /** @type {HTMLDivElement} */
    sidebar;
    /** @type {boolean} */
    showSidebar;
    /** @type {Fieldset} */
    worlds;
    /** @type {Fieldset} */
    players;

    /**
     * @param {Settings_UI_Sidebar} json
     * @param {boolean} show
     */
    constructor(json, show) {
        this.sidebar = S.createElement("div", "sidebar", this);
        this.showSidebar = show;
        if (!show) {
            this.sidebar.style.display = "none";
        }
        this.sidebar.addEventListener("click", (e) => {
            S.playerList.followPlayerMarker(null);
            e.stopPropagation();
        });
        document.body.appendChild(this.sidebar);

        // Forced Swedish labels (so it reads correctly on stock squaremap too).
        this.worlds = new Fieldset("worlds", "Världar");
        this.sidebar.appendChild(this.worlds.element);

        this.players = new Fieldset("players", "Spelare ( 0 )");
        this.sidebar.appendChild(this.players.element);

        // Respect the initial visibility; the top-right toggle shows/hides it.
        this.show(show);
    }

    show(show) {
        this.showSidebar = show;
        this.sidebar.className = show ? "show" : "";
        // keep the inline display in sync so the toggle button can't desync
        this.sidebar.style.display = show ? "" : "none";
    }

    remove() {
        this.sidebar.remove();
    }
}

export { Sidebar };
